import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  radialGradient: {
    flex: 1,
  },
});
